import axios from "./axios"; // Import the centralized Axios instance

const state = {
  warehouses: [],
};

const getters = {
  allWarehouses: (state) => state.warehouses,
};

const actions = {
  async fetchWarehouses({ commit }) {
    try {
      commit("resetWarehouses");
      const response = await axios.get("/warehouse", { params: { page: 1, limit: 25 } });
      commit("setWarehouses", response.data);
    } catch (error) {
      console.error("Failed to fetch warehouses:", error);
    }
  },
  async createWarehouse({ commit }, warehouse) {
    try {
      const response = await axios.post("/warehouse", warehouse);
      commit("addWarehouse", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create warehouse:", error);
      throw error;
    }
  },
  async fetchWarehouseById(_, id) {
    try {
      const response = await axios.get(`/warehouse/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch warehouse:", error);
      throw error;
    }
  },
  async updateWarehouse({ commit }, warehouse) {
    try {
      const response = await axios.put(`/warehouse/${warehouse.id}`, warehouse);
      commit("updateWarehouse", response.data);
    } catch (error) {
      console.error("Failed to update warehouse:", error);
      throw error;
    }
  },
  async deleteWarehouseById({ commit }, id) {
    try {
      const response = await axios.delete(`/warehouse/${id}`);
      commit("removeWarehouse", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete warehouse:", error);
      throw error;
    }
  },
};

const mutations = {
  setWarehouses(state, warehouses) {
    state.warehouses = warehouses.data; // Ensure this matches your API's response structure
  },
  addWarehouse(state, warehouse) {
    state.warehouses.push(warehouse);
  },
  updateWarehouse(state, updatedWarehouse) {
    const index = state.warehouses.findIndex(
      (warehouse) => warehouse.id === updatedWarehouse.id
    );
    if (index !== -1) {
      state.warehouses.splice(index, 1, updatedWarehouse);
    }
  },
  removeWarehouse(state, id) {
    state.warehouses = state.warehouses.filter(
      (warehouse) => warehouse.id !== id
    );
  },
  resetWarehouses(state) {
    state.warehouses = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
